// extracted by mini-css-extract-plugin
module.exports = {"container":"DeleteableChip_container__2043x","label":"DeleteableChip_label__ppDos","delete":"DeleteableChip_delete__HyX1T"};